import { cn } from "./ui";

/**
 * The mark: a bank statement whose lines each carry a category colour, which is what Codego does.
 * (Same drawing as public/favicon.svg; an earlier tag-shaped version is in public/brand/.)
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className={cn("shrink-0", className)}>
      <path d="M8 2.5h11.2L26 9.3V27.5a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-23a2 2 0 0 1 2-2Z" fill="#0f172a" />
      <path d="M19.2 2.5v5a1.8 1.8 0 0 0 1.8 1.8h5" fill="#475569" />
      <rect x="9.5" y="12.5" width="4" height="3" rx="1" fill="#2dd4bf" />
      <rect x="15" y="12.5" width="7.5" height="3" rx="1.5" fill="#e2e8f0" />
      <rect x="9.5" y="18" width="4" height="3" rx="1" fill="#fbbf24" />
      <rect x="15" y="18" width="5.5" height="3" rx="1.5" fill="#e2e8f0" />
      <rect x="9.5" y="23.5" width="4" height="3" rx="1" fill="#a78bfa" />
      <rect x="15" y="23.5" width="7" height="3" rx="1.5" fill="#e2e8f0" />
    </svg>
  );
}

/** Mark and wordmark: "codego", lower case, with "go" in the brand colour. */
export function Logo({ size = "md" }: { size?: "md" | "lg" }) {
  return (
    <span className="flex items-center gap-2" role="img" aria-label="Codego">
      <LogoMark className={size === "lg" ? "size-9" : "size-8"} />
      <span
        className={cn(
          "font-bold tracking-[-0.04em] text-slate-900",
          size === "lg" ? "text-[22px]" : "text-[19px]",
        )}
      >
        code<span className="text-brand-600">go</span>
      </span>
    </span>
  );
}
